import styled from "styled-components";

export const HeaderContainer = styled("div")`
  padding: 0 24px;
  background: #fafafa;
  border-bottom: 1px solid #e8e8e8;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 48px;
  @media (max-width: 768px) {
    justify-content: space-between;
    padding: 0 12px;
  }
`;

export const MenuBtn = styled("button")`
  display: none;
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: #333;
  padding: 4px 8px;
  @media (max-width: 768px) {
    display: flex;
    align-items: center;
  }
`;

export const NavLinks = styled("div")`
  a {
    display: inline-flex;
    align-items: center;
    color: #333;
    font-size: 13px;
    font-weight: 600;
  }
  .ant-dropdown-trigger {
    padding: 6px 12px;
    border-radius: 6px;
    transition: background 0.15s;
    &:focus,
    &:focus-within,
    &:hover {
      background: #e8e8e8;
      color: #000000;
    }
  }
`;
